import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import RecoveryPage from "../pages/recover-page";
import { Wrapper } from "./student-app";

import styled from 'styled-components'

// import EmailAwaitPage from "components/pages/auth/email-await-page";
// import CreatePasswordPage from "components/pages/auth/create-password-page";
import AboutProgramPage from "components/pages/about-program-page";
import ScienceProgramPage from "components/pages/science-products-page";
import ScienceSelectPage from "components/pages/science-select-page";
import ScienceLabsPage from "components/pages/science-labs-page";
import LoginPage from "components/pages/auth/login-page";
import SignUpPage from "components/pages/auth/signup-page";
import DevPage from "components/pages/dev-app";
import DormitoryPublicPage from "components/pages/dormitory-public-page";
import EventsPublicPage from "components/pages/events-public-page";
import EventsSearchPage from "components/pages/events-search-page";
import LabPublicPage from "components/pages/lab-public-page";
import LabsSearchPage from "components/pages/labs-search-page";
import MainLandingPage from "components/pages/main-landing-page";
import NewsArticlePage from "components/pages/news-article-page";
import NewsListPage from "components/pages/news-list-page";
import PartnersPage from "components/pages/partners-page";
import SearchResultsPage from "components/pages/search-results-page";
import UniversiesPage from "components/pages/universities-page";
import ClubsPage from "components/pages/clubs-page";
import UniversityPublicPage from "components/pages/university-public-page";
import FooterComponent from "components/tools/FooterComponent";
import Header from "components/tools/header";

import { ERoles } from "types/enums";
import AboutProgramPage2 from "../pages/about-program-page2";
import ContactsPage from "../pages/contacts-page";
import AmbassadorsListPage from "../pages/ambassadors-list-page";
import AmbassadorPage from "../pages/ambassador-page";
import InternationalPage from "../pages/international-page";
import PatriotPage from "../pages/patriot-page";
import IndustrialPage from "../pages/industrial-page";
import { useTranslation } from "react-i18next";
import ClubPublicPage from "../pages/club-public-page";
import FaqPage from "../pages/faq-page";
import IntensivePage from "../pages/intensive-page";


const GuestApp = () => {
    const { pathname } = useLocation();
    const isAuthPage = [`/login`, `/registration/student`, `/registration/university`].includes(pathname);
    const { t, i18n } = useTranslation();

    const guestNavItems = [
        { name: t("kd0cxu9aj0d"), to: "/about-program" },
        { name: t("grz2p1n8qr"), to: "/news" },
        { name: t("9sqjqe0i5dp"), to: "/universities" },
        { name: t("1kjjamjlil5"), to: "/search" },
        { name: t("boc9nan75af"), to: "/events-search" },
        { name: t("1kjjamjlil6"), to: "/science" },
        { name: t("1nwvn4sd0cb"), to: "/partners" },
        { name: t("ambassadors"), to: "/ambassadors" },
        // { name: "Куда поехать", to: "/search" },
        // { name: "Зачем поехать", to: "/events" },
        // { name: "Новости", to: "/news" },
        {
            name: t("ly2nfd3sir"),
            to: "/about-program",
            onClick: () => {
                try {
                    document.querySelector("#footer").scrollIntoView({
                        behavior: "auto"
                    });
                } catch (exc) {
                }
            }
        }

        // { name: "Организации", to: "/universities" },
    ];

    return (
        <>
            <Wrapper className={"guest_app"}>
                {!isAuthPage && <Header />}
                {/*{<Header />}*/}
                <Routes>
                    <Route path="/recover/:recoveryKey" element={<RecoveryPage />} />
                    <Route path="/" element={<MainLandingPage />} />
                    <Route path="/about-program" element={<AboutProgramPage2 />} />
                    <Route path="/about-program2" element={<AboutProgramPage2 />} />
                    <Route path="/contacts" element={<ContactsPage />} />
                    <Route path="/faq" element={<FaqPage />} />
                    <Route path="/intensive" element={<IntensivePage />} />
                    <Route path="/partners" element={<PartnersPage />} />
                    <Route path="/international" element={<InternationalPage />} />
                    <Route path="/patriot" element={<PatriotPage />} />
                    <Route path="/industrial" element={<IndustrialPage />} />
                    <Route path="/dev" element={<DevPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    {/* <Route path={`/dormitories/:dormitoryId`} element={<PublicDormitoryPage />} /> */}
                    <Route path="/dormitory/:dormitoryId" element={<DormitoryPublicPage />} />
                    <Route path="/labs-search" element={<LabsSearchPage />} />
                    <Route path="/lab/:labId" element={<LabPublicPage />} />
                    <Route path="/club/:clubId" element={<ClubPublicPage/>} />
                    <Route path="/registration/student" element={<SignUpPage role={ERoles.Student} />} />
                    <Route path="/registration/university" element={<SignUpPage role={ERoles.University} />} />
                    <Route path="/search" element={<SearchResultsPage />} />
                    <Route path="/events/:eventId" element={<EventsPublicPage />} />
                    <Route path="/events-search" element={<EventsSearchPage />} />
                    <Route path="/science-labs" element={<ScienceLabsPage />} />
                    <Route path="/science-products" element={<ScienceProgramPage />} />
                    <Route path="/ambassadors" element={<AmbassadorsListPage />} />
                    <Route path="/science" element={<ScienceSelectPage />} />
                    <Route path="/universities" element={<UniversiesPage />} />
                    <Route path="/clubs" element={<ClubsPage />} />
                    <Route path="/university/:universityId" element={<UniversityPublicPage />} />
                    <Route path="/news" element={<NewsListPage />} />
                    <Route path="/news/:newsId" element={<NewsArticlePage />} />
                    <Route path="/ambassadors/:ambassadorId" element={<AmbassadorPage />} />
                    <Route path="/ambassadors/:ambassadorId/posts/:postId" element={<AmbassadorPage />} />
                    {/* <Route path={`/:role-await`} element={<EmailAwaitPage />} /> */}
                    {/* <Route path={`/create-password/student`} element={<CreatePasswordPage role={ERoles.Student} />} /> */}
                    {/* <Route path={`/create-password/university`} element={<CreatePasswordPage role={ERoles.University} />} /> */}
                    <Route path="/*" element={<Navigate to={`/`} />} />
                </Routes>

                {/*{isAuthPage &&*/}
                {/*    <BottomPlaceholder style={{*/}
                {/*        width: "400px",*/}
                {/*        display: "grid",*/}
                {/*        gridTemplateColumns: "1fr 1fr 1fr ",*/}
                {/*        padding: "10px",*/}
                {/*        marginTop: "30px",*/}
                {/*        marginBottom: "30px"*/}
                {/*    }}>*/}
                {/*        {guestNavItems.map((a, i) => {*/}
                {/*            return (*/}
                {/*                <div key={i} style={{ padding: "7px", cursor: "pointer", fontSize: "12px" }}*/}
                {/*                     onClick={() => window.location.href = a.to}>*/}
                {/*                    {a.name}*/}
                {/*                </div>*/}
                {/*            );*/}
                {/*        })}*/}
                {/*    </BottomPlaceholder>*/}
                {/*}*/}

                <FooterComponent />

            </Wrapper>
        </>
    );
};

export default GuestApp;

const BottomPlaceholder = styled.div`
  width: 400px;
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
  background: white;
  @media(max-width: 768px) {
    margin-bottom: 40px;
    width: 100%;
    margin-top: 30px;
  }
`;